@if (!!parentFormGroup().get(controlName())) {
  <div class="font-regular password-field-container">
    <div class="hints-popup"
         [class.visible]="showHints() && showHint()"
         [class.left]="popupPosition() === 'left'"
         [class.right]="popupPosition() === 'right'"
         [class.top]="popupPosition() === 'top'"
         [class.bottom]="popupPosition() === 'bottom'"
         [class.narrow-container]="isInNarrowContainer()"
    >
      @if (isConfirmPassword()) {
        <div class="popup-heading">Confirm Password</div>
        <hr class="popup-divider"/>
        <ul class="password-requirements">
          <li [class.valid-hint]="confirmPasswordMatches()">Must match with password.</li>
        </ul>
      } @else {
        <div class="popup-heading">The password must have:</div>
        <hr class="popup-divider"/>
        <ul class="password-requirements">
          <li [class.valid-hint]="hasMinLength()">At least 6 characters</li>
          <li [class.valid-hint]="hasMaxLength()">At most 20 characters</li>
          <li [class.valid-hint]="hasSpecialChar()">At least 1 special character</li>
          <li [class.valid-hint]="hasNumber()">At least 1 number</li>
          <li [class.valid-hint]="hasUpperCase()">At least 1 upper case character</li>
          <li [class.valid-hint]="hasLowerCase()">At least 1 lower case character</li>
        </ul>
      }

    </div>
    <mat-form-field
      [formGroup]="parentFormGroup()"
      appearance="outline"
      class="form-field w-full"
      [class.small]="type() === 'small'"
      [class.hide-subscript]="hideSubscript()"
    >
      <mat-label>{{ label() }}</mat-label>
      @if (autocomplete()) {
        <input
          #passwordInput
          [formControlName]="controlName()"
          class="input text-input"
          matInput
          [placeholder]="placeholder()"
          [type]="showPassword() ? 'text' : 'password'"
          (focus)="onFocus()"
        >
      } @else {
        <input
          #passwordInput
          [formControlName]="controlName()"
          class="input text-input"
          matInput
          [placeholder]="placeholder()"
          [type]="showPassword() ? 'text' : 'password'"
          (focus)="onFocus()"
          autocomplete="new-password"
        >
      }
      <mat-icon
        matSuffix
        class="suffix-icon"
        (click)="togglePasswordVisibility()"
        [svgIcon]="showPassword() ? 'eye-closed' : 'eye-open'"
      />

      <mat-error *ngIf="error()">{{ error() }}</mat-error>
    </mat-form-field>
  </div>
}

